import React, { useEffect, useState } from 'react';
import { compose, lifecycle } from 'recompose';
import { connect } from '../../../redux/store';
import { actions as portfolioActions } from '../../../redux/modules/settingsPortfolio';
import { actions as serviceActions } from '../../../redux/modules/settingsService';
import { actions as appendixActions } from '../../../redux/modules/settingsAppendix';
import { ContentManager } from './ContentManager';
import { CONTENT_MANAGER_MODE } from './helpers';
import { ErrorMessage, LoadingMessage, C } from '@kineticdata/bundle-common';
import { fetchSubmission } from '@kineticdata/react';

const enhance = compose(
  connect(
    (state, props) => ({
      portfoliosFetched: state.settingsPortfolio.dataInit,
      servicesFetched: state.settingsService.dataInit,
      appendicesFetched: state.settingsAppendix.dataInit,
    }),
    {
      fetchPortfolios: portfolioActions.fetchPortfoliosRequest,
      fetchServices: serviceActions.fetchServicesRequest,
      fetchAppendices: appendixActions.fetchAppendicesRequest,
    },
  ),
  lifecycle({
    componentDidMount() {
      if (!this.props.portfoliosFetched) {
        this.props.fetchPortfolios();
      }
      if (!this.props.servicesFetched) {
        this.props.fetchServices();
      }
      if (!this.props.appendicesFetched) {
        this.props.fetchAppendices();
      }
    },
  }),
);

export const ContentManagerReview = enhance(({ id }) => {
  const [submission, setSubmission] = useState(null);
  const [error, setError] = useState(null);
  useEffect(
    () => {
      if (id) {
        fetchSubmission({ id, include: 'details,values,form' }).then(
          ({ submission, error }) => {
            if (error) {
              setError(error);
            } else if (
              submission &&
              submission.form.type === 'Datastore' &&
              [
                C.FORM_SLUG_PORTFOLIO,
                C.FORM_SLUG_SERVICE,
                C.FORM_SLUG_APPENDIX,
              ].includes(submission.form.slug)
            ) {
              setSubmission(submission);
            } else {
              setError({
                message:
                  'The submission attached to this approval is invalid. It is not a service catalog content submission.',
              });
            }
          },
        );
      }
    },
    [id],
  );

  return (
    <>
      {error ? (
        <ErrorMessage
          title="The content failed to load."
          message={error.message}
        />
      ) : !submission ? (
        <LoadingMessage />
      ) : (
        <div className="bg-white p-4 mx-n4 mb-4 border-light border-left border-right">
          <ContentManager
            submission={submission}
            mode={CONTENT_MANAGER_MODE.REVIEW}
            indexSections={submission.form.slug === C.FORM_SLUG_APPENDIX}
            enableSearch={submission.form.slug === C.FORM_SLUG_APPENDIX}
          />
        </div>
      )}
    </>
  );
});
